var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleDirectory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_399_113)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.30305 10C4.30305 9.36489 4.40853 8.756 4.5968 8.18489L1.30145 5.66844C0.65921 6.97244 0.297363 8.44177 0.297363 10C0.297363 11.5569 0.658765 13.0253 1.30012 14.3284L4.59368 11.8071C4.40719 11.2387 4.30305 10.632 4.30305 10Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0888 4.22222C11.4686 4.22222 12.7148 4.71111 13.694 5.51111L16.5424 2.66666C14.8066 1.15555 12.5813 0.222218 10.0888 0.222218C6.21936 0.222218 2.89375 2.43511 1.30127 5.66844L4.59661 8.18488C5.35591 5.88 7.52031 4.22222 10.0888 4.22222Z",
    fill: "#EB4335"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0888 15.7778C7.52031 15.7778 5.35591 14.12 4.59661 11.8151L1.30127 14.3311C2.89375 17.5649 6.21936 19.7778 10.0888 19.7778C12.4771 19.7778 14.7572 18.9298 16.4686 17.3409L13.3406 14.9227C12.458 15.4787 11.3466 15.7778 10.0888 15.7778Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4355 10C19.4355 9.42222 19.3464 8.8 19.2129 8.22222H10.0889V12H15.3408C15.0782 13.288 14.3634 14.2782 13.3406 14.9227L16.4686 17.3409C18.2662 15.6724 19.4355 13.1871 19.4355 10Z",
    fill: "#4285F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_399_113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDirectory);
export default __webpack_public_path__ + "static/media/google-directory.036542efd6398535cdce80f131496363.svg";
export { ForwardRef as ReactComponent };